import i18next from 'i18next';
import {
  IParameter,
  ParameterCategory,
  ParameterType,
} from 'src/store/models/Device';

export enum DeviceVariables {
  FAN_1_SPEED = 4,
  CURRENT_POWER = 5,
  GASSES_TEMPERATURE = 11,
  FAN_2_SPEED = 12,
  BACKWATTER_TEMPERATURE = 22,
  TIME_SECONDS = 23,
  TIME_MINUTES = 24,
  TIME_HOUR = 25,
  DAY_OF_WEEK = 26,
  UP_TIME = 15,
  HEATING_TIME = 17,
  SERVICE_TIME = 19,
  DATE_DAY = 27,
  DATE_MONTH = 28,
  DATE_YEAR = 29,
  I01 = 30,
  I02 = 31,
  I03 = 32,
  I04 = 33,
  F02 = 34,
  PRESSURE = 35,
  STOVE_MODEL = 96,
  PARAMETER_VERSION = 97,
  EXTERNAL_THERMOSTAT_ENABLED = 98,
  EXTERNAL_THERMOSTAT_CONTACT = 99,

  ERROR_LOG_ID_1 = 36,
  ERROR_LOG_VAL_1 = 37,
  ERROR_LOG_DATE_1 = 38,
  ERROR_LOG_TIME_1 = 39,
  ERROR_LOG_ID_2 = 40,
  ERROR_LOG_VAL_2 = 41,
  ERROR_LOG_DATE_2 = 42,
  ERROR_LOG_TIME_2 = 43,
  ERROR_LOG_ID_3 = 44,
  ERROR_LOG_VAL_3 = 45,
  ERROR_LOG_DATE_3 = 46,
  ERROR_LOG_TIME_3 = 47,
  ERROR_LOG_ID_4 = 48,
  ERROR_LOG_VAL_4 = 49,
  ERROR_LOG_DATE_4 = 50,
  ERROR_LOG_TIME_4 = 51,
  ERROR_LOG_ID_5 = 52,
  ERROR_LOG_VAL_5 = 53,
  ERROR_LOG_DATE_5 = 54,
  ERROR_LOG_TIME_5 = 55,
  ERROR_LOG_ID_6 = 56,
  ERROR_LOG_VAL_6 = 57,
  ERROR_LOG_DATE_6 = 58,
  ERROR_LOG_TIME_6 = 59,
  ERROR_LOG_ID_7 = 60,
  ERROR_LOG_VAL_7 = 61,
  ERROR_LOG_DATE_7 = 62,
  ERROR_LOG_TIME_7 = 63,
  ERROR_LOG_ID_8 = 64,
  ERROR_LOG_VAL_8 = 65,
  ERROR_LOG_DATE_8 = 66,
  ERROR_LOG_TIME_8 = 67,
  ERROR_LOG_ID_9 = 68,
  ERROR_LOG_VAL_9 = 69,
  ERROR_LOG_DATE_9 = 70,
  ERROR_LOG_TIME_9 = 71,
  ERROR_LOG_ID_10 = 72,
  ERROR_LOG_VAL_10 = 73,
  ERROR_LOG_DATE_10 = 74,
  ERROR_LOG_TIME_10 = 75,
  ERROR_LOG_ID_11 = 76,
  ERROR_LOG_VAL_11 = 77,
  ERROR_LOG_DATE_11 = 78,
  ERROR_LOG_TIME_11 = 79,
  ERROR_LOG_ID_12 = 80,
  ERROR_LOG_VAL_12 = 81,
  ERROR_LOG_DATE_12 = 82,
  ERROR_LOG_TIME_12 = 83,
  ERROR_LOG_ID_13 = 84,
  ERROR_LOG_VAL_13 = 85,
  ERROR_LOG_DATE_13 = 86,
  ERROR_LOG_TIME_13 = 87,
  ERROR_LOG_ID_14 = 88,
  ERROR_LOG_VAL_14 = 89,
  ERROR_LOG_DATE_14 = 90,
  ERROR_LOG_TIME_14 = 91,
  ERROR_LOG_ID_15 = 92,
  ERROR_LOG_VAL_15 = 93,
  ERROR_LOG_DATE_15 = 94,
  ERROR_LOG_TIME_15 = 95,
}

export enum DeviceTimers {
  PROG_1_ON_HOUR = 0,
  PROG_1_ON_MINUTE = 1,
  PROG_1_OFF_HOUR = 2,
  PROG_1_OFF_MINUTE = 3,

  PROG_2_ON_HOUR = 4,
  PROG_2_ON_MINUTE = 5,
  PROG_2_OFF_HOUR = 6,
  PROG_2_OFF_MINUTE = 7,

  PROG_3_ON_HOUR = 8,
  PROG_3_ON_MINUTE = 9,
  PROG_3_OFF_HOUR = 10,
  PROG_3_OFF_MINUTE = 11,

  PROG_4_ON_HOUR = 12,
  PROG_4_ON_MINUTE = 13,
  PROG_4_OFF_HOUR = 14,
  PROG_4_OFF_MINUTE = 15,

  PROG_5_ON_HOUR = 30,
  PROG_5_ON_MINUTE = 31,
  PROG_5_OFF_HOUR = 32,
  PROG_5_OFF_MINUTE = 33,

  PROG_6_ON_HOUR = 34,
  PROG_6_ON_MINUTE = 35,
  PROG_6_OFF_HOUR = 36,
  PROG_6_OFF_MINUTE = 37,

  DAY_1_1 = 16,
  DAY_1_2 = 17,
  DAY_1_3 = 38,
  DAY_2_1 = 18,
  DAY_2_2 = 19,
  DAY_2_3 = 39,
  DAY_3_1 = 20,
  DAY_3_2 = 21,
  DAY_3_3 = 40,
  DAY_4_1 = 22,
  DAY_4_2 = 23,
  DAY_4_3 = 41,
  DAY_5_1 = 24,
  DAY_5_2 = 25,
  DAY_5_3 = 42,
  DAY_6_1 = 26,
  DAY_6_2 = 27,
  DAY_6_3 = 43,
  DAY_7_1 = 28,
  DAY_7_2 = 29,
  DAY_7_3 = 44,

  PROG_1_TEMPERATURE = 45,
  PROG_2_TEMPERATURE = 46,
  PROG_3_TEMPERATURE = 47,
  PROG_4_TEMPERATURE = 48,
  PROG_5_TEMPERATURE = 49,
  PROG_6_TEMPERATURE = 50,
}

export enum DeviceErrorCodes {
  CLEANING_CODE = 8,
  DOOR_OPENED_CODE = 239,
  FIRE_ERROR_CODE = 240,
  CHIMNEY_DIRTY_CODE = 241,
  NTC2_CODE = 244,
  NTC3_CODE = 245,
  TC2_CODE = 246,
  SECURITY_SWITCH_CODE = 247,
  PRESSURE_SWITCH_CODE = 248,
  NTC1_CODE = 249,
  TC1_CODE = 250,
  GASSES_OVER_TEMPERATURE_CODE = 252,
  NO_PELLETS_CODE = 253,
  GENERAL_ERROR_CODE = 254,
}

export interface TemperatureVariable {
  label: string;
  temperatureId?: number;
  variableId?: number;
  minValue: number;
  maxValue: number;
  value?: number;
}

export const TEMPERATURE_COMBUSTION_CHAMBER = 7;

export const parameterCategories: ParameterCategory[] = [
  {
    label: i18next.t('parameter_categories:alarm_timeout'),
    parameters: [0, 1],
  },
  {
    label: i18next.t('parameter_categories:fuel_type'),
    parameters: [2],
  },
  {
    label: `${i18next.t('parameter_categories:feeder')} 1`,
    parameters: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  },
  {
    label: `${i18next.t('parameter_categories:fan')} 1`,
    parameters: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
  },
  {
    label: `${i18next.t('parameter_categories:fan')} 2`,
    parameters: [29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
  },
  {
    label: `${i18next.t('parameter_categories:fan')} 3`,
    parameters: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
  },
  {
    label: i18next.t('parameter_categories:water_air'),
    parameters: [50, 51, 52, 53],
  },
  {
    label: i18next.t('parameter_categories:gases'),
    parameters: [54, 55, 56, 57, 58, 59],
  },
  {
    label: i18next.t('parameter_categories:cleaning'),
    parameters: [60, 61, 62, 63, 64, 65, 66],
  },
  {
    label: i18next.t('parameter_categories:cleaning'),
    parameters: [67, 68, 69],
  },
  {
    label: i18next.t('parameter_categories:timing'),
    parameters: [70, 71, 72],
  },
  {
    label: i18next.t('parameter_categories:user_wood_factors'),
    parameters: [73, 74, 75],
  },
  {
    label: i18next.t('parameter_categories:configuration'),
    parameters: [76],
  },
  {
    label: i18next.t('parameter_categories:2nd_room'),
    parameters: [77],
  },
  {
    label: i18next.t('parameter_categories:flame_sensor'),
    parameters: [78, 79, 80],
  },
  {
    label: i18next.t('parameter_categories:press_airflow'),
    parameters: [81, 82, 83],
  },
  {
    label: i18next.t('parameter_categories:heat_acc'),
    parameters: [84, 85, 86],
  },
  {
    label: i18next.t('parameter_categories:keep_fire'),
    parameters: [87, 88, 89, 90],
  },
  {
    label: `${i18next.t('parameter_categories:feeder')} 2`,
    parameters: [91],
  },
  {
    label: i18next.t('parameter_categories:fuel_quality'),
    parameters: [92, 93],
  },
  {
    label: i18next.t('parameter_categories:service'),
    parameters: [94],
  },
  {
    label: i18next.t('parameter_categories:special_water'),
    parameters: [95, 96, 97],
  },
  {
    label: i18next.t('parameter_categories:leveltronic'),
    parameters: [98, 99, 100],
  },
  {
    label: i18next.t('parameter_categories:extra'),
    parameters: [101, 102, 103, 104, 105],
  },
];

export const fanVariables: IParameter[] = [
  {
    name: 'sMotorFAN1',
    minValue: 0,
    maxValue: 100,
    defaultValue: 0,
    hexAddress: 'C03C',
    logGraph: true,
    numBytes: 1,
    parameterGroupId: 9,
    parameterIdRcu: 4,
    parameterType: ParameterType.VARIABLE,
  },
  {
    name: 'sMotorFAN2',
    minValue: 0,
    maxValue: 100,
    defaultValue: 0,
    hexAddress: 'C045',
    logGraph: true,
    numBytes: 1,
    parameterGroupId: 9,
    parameterIdRcu: 12,
    parameterType: ParameterType.VARIABLE,
  },
];

export const temperatureVariables: TemperatureVariable[] = [
  {
    label: i18next.t('device_parameters:room'),
    temperatureId: 1,
    minValue: -55,
    maxValue: 300,
  },
  {
    label: i18next.t('parameter_categories:2nd_room'),
    temperatureId: 2,
    minValue: -55,
    maxValue: 300,
  },
  {
    label: i18next.t('device_parameters:oven'),
    temperatureId: 3,
    minValue: -20,
    maxValue: 1200,
  },
  {
    label: i18next.t('device_parameters:accumulator_water'),
    temperatureId: 4,
    minValue: -55,
    maxValue: 300,
  },
  {
    label: i18next.t('device_parameters:stove_water'),
    temperatureId: 5,
    minValue: -55,
    maxValue: 300,
  },
  {
    label: i18next.t('device_parameters:boiler_water'),
    temperatureId: 6,
    minValue: -55,
    maxValue: 300,
  },
  {
    label: i18next.t('device_parameters:gases_temperature'),
    variableId: 11,
    minValue: -20,
    maxValue: 1200,
  },
];
